//  Name: upload-image
export default {
  props: {
    url: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      state: null, // null = normal, -1 = error, 0 = waiting, 1 = success
      message: null,
      image: null,
    }
  },
  computed: {
    css () {
      var result = ''
      if (this.state === -1) {
        result = 'has-error'
      }
      if (this.state === 1) {
        result = 'has-success'
      }
      return result
    }
  },
  methods: {
    upload: function(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length)
        return;

      var data = new FormData()
      var vm = this
      data.append('image', files[0])

      vm.uploading()

      this.$http.post(this.url, data)
      .then(function (data) {
        if (data.body.status === 'ok') {
          vm.success(data.body.image)
        } else {
          vm.error(data.body.message)
        }
      }, function (data) {
        console.log(data)
        vm.error('Error de comunicación con el servidor, intentelo más tarde')
      })
    },
    uploading () {
      this.state = 0
      this.$emit('onWaiting', 'Subiendo imagen...')
    },
    success (url) {
      this.state = 1
      this.$emit('onSuccess', url)
      console.log('onSuccess')
    },
    error (error) {
      this.state = -1
      this.$emit('onError', error)
      console.log('onError')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/upload-image/script.js